import _ from "lodash";
import {
  FETCH_CONNECTIONS,
  FETCH_CONNECTION,
  FETCH_ACTION_FIELDS,
  FETCH_ACTION_METAFIELDS,
  SAVE_ACTION_FIELDS,
  CREATE_CONNECTOR,
  ENABLE_CONNECTION,
  SET_CLICKED_CONNECTOR,
  SET_LATEST_OAUTH_REDIRECT_LINK,
  DISABLE_CONNECTOR,
  CLEAR_DISABLE_CONNECTOR_RESPONSE,
  CREATE_PUBLIC_CONNECTOR,
  SET_PUBLIC_CHATBOT_SNIPPET_METADATA
} from "../actions/types";


export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_CONNECTIONS:
      _.forEach(action.payload, (connections, key) => {
        // Ignore fallbackIntent since it does not contain a list of connectors (it contains fallback intent data)
        if (key === "fallbackIntent") {
          return;
        }

        _.forEach(connections, connection => {
          connection.visible = true;
        });
      });

      return {
        ...state,
        ...action.payload
      };

    case FETCH_CONNECTION:
      return {
        ...state,
        connection: action.payload
      };

    case FETCH_ACTION_FIELDS:
      return {
        ...state,
        fields: action.payload,
        status: action.payload.status?500:null
      };

    case FETCH_ACTION_METAFIELDS:
      return {
        ...state,
        metafields: Array.isArray(action.payload)?action.payload.map(item => item._source):action.payload
      }
    
    case SAVE_ACTION_FIELDS:
      return {
        ...state,
        saveStatus: action.payload
      } 
    case CREATE_CONNECTOR:
      return {
        ...state,
        enabledConnection: {
          createConnectionStatus: action.payload.status,
          oauthRedirectUrl: action.payload.oauthRedirectUrl,
          connectionId: action.payload.connectionId
        }
      };
    case CREATE_PUBLIC_CONNECTOR:
      return {
        ...state,
        enabledConnection: {
          createConnectionStatus: action.payload.status,
          connectionId: action.payload.connectionId
        }
      };
    case ENABLE_CONNECTION:
      return {
        ...state,
        oauthStatus: action.payload
      };
    case SET_CLICKED_CONNECTOR:
      return {
        ...state,
        selectedConnection: action.payload
      };
    case SET_LATEST_OAUTH_REDIRECT_LINK:
      return {
        ...state,
        latestOAuthRedirectLink: {
          createConnectionStatus: action.payload.status,
          oauthRedirectUrl: action.payload.oauthRedirectUrl,
          connectionId: action.payload.connectionId
        }
      };
    case DISABLE_CONNECTOR:
      return {
        ...state,
        disableConnectorResponse: action.payload.response
      };
    case SET_PUBLIC_CHATBOT_SNIPPET_METADATA:
      return {
        ...state,
        publicChatbotProps: action.payload
      };
    case CLEAR_DISABLE_CONNECTOR_RESPONSE:
      return _.omit(state, ["disableConnectorResponse"]);
    default:
      return state;
  }
}
